module.exports = __webpack_public_path__ + "img/chara_6.9f58720c.png";